var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"style-button-group"},_vm._l((_vm.galleries),function(gallery){return _c('ix-router-link',{key:'gb' + gallery.gallery_id,staticClass:"button grey",attrs:{"to":gallery.url}},[_vm._v(_vm._s(gallery.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }